import { tw as o } from "../../utils/tailwind.js";
var a = /* @__PURE__ */ ((t) => (t.CLOSED = "closed", t.OPENED = "opened", t))(a || {});
const s = {
  enterActiveClass: o`motion-safe:transition-transform motion-safe:duration-300 md:motion-safe:transition-opacity`,
  enterFromClass: o`translate-y-full md:opacity-0`,
  leaveActiveClass: o`motion-safe:transition-transform motion-safe:duration-200 md:motion-safe:transition-opacity`,
  leaveToClass: o`translate-y-full md:opacity-0`
};
var i = /* @__PURE__ */ ((t) => (t.Mid = "mid", t.Low = "low", t))(i || {});
export {
  i as BackgroundColorsEnum,
  a as ModalStatusEnum,
  s as defaultModalTransitionClasses
};
